import { ActivityLogPromiseClient } from '@trustero/trustero-api-web/lib/activity/activity_grpc_web_pb'
import { MODEL_TYPE } from '@trustero/trustero-api-web/lib/common/model_pb'
import {
  GetActivityLogRequest,
  GetActivityLogCitationRequest,
  ActivityLogEntries,
  ACTIVITY_CITATION_TYPE,
} from '@trustero/trustero-api-web/lib/activity/activity_pb'
import { useInAudit } from 'src/context/AuditContext'
import {
  GrpcInfiniteResponse,
  NewGrpcInfiniteResponse,
} from '../../components/async/hooks/types'
import { useSwrInfiniteGrpc } from '../../components/async/useSwrInfiniteGrpc'

const MODEL_TO_CITATION_TYPE: Partial<
  Record<MODEL_TYPE, ACTIVITY_CITATION_TYPE>
> = {
  [MODEL_TYPE.AUDIT]: ACTIVITY_CITATION_TYPE.AUDIT,
  [MODEL_TYPE.COMPLIANCE_FRAMEWORK]: ACTIVITY_CITATION_TYPE.FRAMEWORK,
  [MODEL_TYPE.POLICY]: ACTIVITY_CITATION_TYPE.POLICY,
  [MODEL_TYPE.CONTROL]: ACTIVITY_CITATION_TYPE.CONTROL,
  [MODEL_TYPE.EVIDENCE]: ACTIVITY_CITATION_TYPE.EVIDENCE,
  [MODEL_TYPE.REQUEST]: ACTIVITY_CITATION_TYPE.REQUEST,
  [MODEL_TYPE.RISK]: ACTIVITY_CITATION_TYPE.RISK,
  [MODEL_TYPE.VENDOR]: ACTIVITY_CITATION_TYPE.VENDOR,
  [MODEL_TYPE.RECEPTOROBJ]: ACTIVITY_CITATION_TYPE.RECEPTOR_OBJ,
  [MODEL_TYPE.SCHEDULE]: ACTIVITY_CITATION_TYPE.SCHEDULE,
  [MODEL_TYPE.QUESTIONNAIRE]: ACTIVITY_CITATION_TYPE.QUESTIONNAIRE,
  [MODEL_TYPE.USEROBJ]: ACTIVITY_CITATION_TYPE.USER_OBJ,
}

export const useChangeLogEntries = (
  itemsPerPage: number,
  pageNumber: number,
  subjectModelIds?: string[],
  subjectIds?: string[],
  subjectType?: MODEL_TYPE,
): GrpcInfiniteResponse<ActivityLogEntries> => {
  const { auditId } = useInAudit()
  const targetId =
    (subjectModelIds && subjectModelIds[0]) || (subjectIds && subjectIds[0])
  const citationType = subjectType
    ? MODEL_TO_CITATION_TYPE[subjectType]
    : undefined

  const serviceMethod = targetId
    ? ActivityLogPromiseClient.prototype.getActivityLogsCitation
    : ActivityLogPromiseClient.prototype.getActivityLogs

  const requestBuilder = () => {
    if (targetId) {
      const request = new GetActivityLogCitationRequest()
        .setEntriesPerPage(itemsPerPage)
        .setPageNumber(pageNumber)
        .setCitationId(targetId)
      if (citationType !== undefined) {
        request.setCitationType(citationType)
      }
      if (auditId) {
        request.setAuditId(auditId)
      }
      return request
    }

    const request = new GetActivityLogRequest()
      .setEntriesPerPage(itemsPerPage)
      .setPageNumber(pageNumber)
    if (auditId) {
      request.setAuditId(auditId)
    }
    return request
  }

  const { response } = useSwrInfiniteGrpc(
    serviceMethod as unknown as Parameters<typeof useSwrInfiniteGrpc>[0],
    requestBuilder,
    pageNumber,
  )
  return NewGrpcInfiniteResponse(response)
}
